import React from 'react';

import Button from '@components/button/Button';
import Switch from '@components/switch/Switch';
import Modal from '@layouts/modal/Modal';

import { IntegrationDetailsModalProps } from './types';

const CalendarIntegrationDetailsModal: React.FC<
  IntegrationDetailsModalProps
> = ({
  isOpen,
  onClose,
  syncPreferences,
  onSyncPreferenceChange,
  onSave,
  connectedEmail,
  isLoading = false
}) => (
  <Modal
    isOpen={isOpen}
    onCancel={onClose}
    isCloseIconRequired
    className="w-139 p-0"
  >
    <h2 className="border-gray30 border-b px-6 pb-3 pt-6 text-xl font-medium text-content">
      Google Calendar
    </h2>

    <div className="px-6 pb-3 pt-6">
      <div className="flex items-center justify-between border-b border-grey30 pb-4">
        <span className="text-sm text-grey">Connected Account</span>
        <span className="text-sm font-medium text-darkGrey">
          {connectedEmail}
        </span>
      </div>
    </div>

    <div className="px-6 pb-6">
      <h3 className="mb-1 text-base font-semibold text-darkGrey">
        Manage Your Sync Preferences
      </h3>
      <p className="mb-2 text-sm text-grey">
        Choose what to sync with your calendar.
      </p>

      <div className="flex flex-col items-start">
        <Switch
          handleClick={(value) => onSyncPreferenceChange('task', value)}
          value={syncPreferences.task}
          label="Task"
          className="flex-row-reverse"
          labelClassName="ml-2 text-sm font-medium text-gray-700"
        />

        <Switch
          handleClick={(value) => onSyncPreferenceChange('event', value)}
          value={syncPreferences.event}
          label="Event"
          className="flex-row-reverse"
          labelClassName="ml-2 text-sm font-medium text-gray-700"
        />
      </div>
    </div>

    {/* Save Button */}
    <div className="flex justify-end border-t border-gray-200 px-6 pb-6 pt-4">
      <Button
        handleClick={onSave}
        variant="tertiary"
        size="medium"
        label={isLoading ? '' : 'Save'}
        loading={isLoading}
        disabled={isLoading}
        className="min-w-[80px] rounded-lg bg-gray-100 px-6 py-2 font-medium text-gray-700 transition-colors duration-200 hover:bg-gray-200"
      />
    </div>
  </Modal>
);

export default CalendarIntegrationDetailsModal;
